module.exports = __webpack_public_path__ + "img/menu-btn.706c1d07.svg";